require('../bootstrap');
import * as func from '../functions';
import Swal from 'sweetalert2'

$(document).ready(function() {
    const favorites = {
        isLoading: false,
        init() {
            $(document).on('click', '.car-favorite-btn', this, this.save);
        },
        save(event) {
            const _this = event.data;

			let id = $(this).data('id');
            let action = $(this).data('action');
			let element = this;

            let url = `${baseURL}/vehicle/favorite/add`;
            if (action == '0') {
                url = `${baseURL}/vehicle/favorite/remove`;
            }

            if (_this.isLoading) {
                return false;
            }

			//Loading...
            _this.isLoading = true;

            var values = '_token=' + $("meta[name=csrf-token]").attr('content');
			values += '&id=' + id;

            $.ajax({
                type: "POST",
                url: url,
                data: values,
                beforeSend: function() {
                    _this.isLoading = true;
                },
                complete: function() {
                    _this.isLoading = false;
                },
                success: function(response, xhr) {
                    _this.isLoading = false;

                    if (response.status == 1) {
						$(element).removeClass('car-show-phone-btn');
                        if (action == '0') {
                            $(element).removeClass('active');
						    $(element).attr('data-action', '1');
                            $('#car-' + id).remove();
                        } else {
                            $(element).addClass('active');
                            $(element).attr('data-action', '0');
                        }
                        if ($('.favorites-counter').length) {
                            $('.favorites-counter').text(response.count);
                        }
                        return;
					}

                    Swal.fire({
                        //icon: 'success',
                        title: 'Eroare!',
                        html: response.message
                    });
                },
                error(error) {
                    _this.isLoading = false;
                },
            });
		}
    };

    if ($('.car-favorite-btn').length) {
        favorites.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/favorites.js